(function () {
    'use strict';

    /* ── CONFIG ────────────────────────────────────────────────────────────────
       Defaults below are overridden by window.TAVI_EXIT_POPUP_CONFIG, which the
       Liquid snippet writes with the values only Liquid knows (logged-in state,
       sale kill switch, money format, routes). Never hard-code those here. */
    var CONFIG = Object.assign({
        discountPct: 0.20,
        maxItemsShown: 2,             // brief: left panel shows up to 2 products
        endpoint: '',            // plain public URL — set from Liquid
        publicKey: '',            // sent as X-TAVI-Key — set from Liquid
        expiryMinutes: 120,           // 2 hours — MUST match `endsAt` on the server
        desktopMinWidth: 768,           // >=768px -> desktop markup (tablets = desktop)
        /* Calculate how much of the left side of the viewport is needed for the exit intent. 
        The browser's back button, address bar, tabs are all on the left. 
        The cart drawer / modal's close button is on the top right — it's not an exit. */
        exitZoneRatio: 0.7,
        /* That's how fast (px/ms) it should go up. Slowly sliding towards X is not an exit. */
        exitMinVelocity: 0.35,
        /* Never popup when drawer/modal is open. Add a selector according to theme */
        overlaySelectors: '.f-drawer-cart[open]',
        /*Remain silent for this many mili second after the drawer closes — the mouse is still in the top-right after pressing X.*/
        /* ── EXIT-INTENT SENSITIVITY ───────────────────────────────────────────
       Every one of these exists to stop the popup firing at someone who is
       not leaving. Raise to be more conservative, lower to catch more exits.
       Turn debug on and watch the console — every suppressed trigger logs its
       reason, so these can be tuned against real behaviour rather than guessed. */

        // Nothing fires for this long after a page loads. People land, orient
        // themselves, and move the mouse around before they have decided anything.
        armDelayMs: 5000,

        // DESKTOP — how far left the pointer must exit. Back button, address bar
        // and tabs are all left of centre. The top-RIGHT corner is where cart
        // drawers and modals put their close button, which is what misfired.
        exitZoneRatio: 0.7,

        // DESKTOP — minimum upward pointer speed, px/ms. Drifting up to click an X
        // is slow; abandoning a page is a fast, committed movement.
        exitMinVelocity: 0.35,

        // Any drawer/modal open = not an exit. Add this theme's cart drawer
        // selector after checking it in DevTools — the generic ones below may not
        // match Horizon.
        // overlaySelectors:       'dialog[open], [aria-modal="true"], cart-drawer[open], .drawer.is-open, .js-drawer-open, .cart-drawer.active',

        // Quiet period after a drawer closes — the pointer is still up there.
        overlayGraceMs: 800,

        // MOBILE — must have been at least this far down the page at some point.
        // Someone who never scrolled was never reading.
        scrollMinDepthPx: 800,

        // MOBILE — the upward flick must cover this much ground...
        scrollUpMinDistancePx: 400,

        // ...within this long. Together these mean "fast flick", not "scrolled up
        // to re-read the product title".
        scrollUpMaxDurationMs: 500,

        // MOBILE — and must finish near the top of the page.
        scrollUpTopPx: 120,

        // MOBILE — ignore scrolls this soon after a tap. Tapping an accordion, a
        // size swatch or an anchor link scrolls the page; that is not an exit.
        /* The back trap is armed only after a real in-site navigation. Someone who
      just landed still has a back button that takes them where they came from;
      pushing a guard entry on their first page load steals that press for a
      popup they have had no chance to be interested in yet.
      Counted in sessionStorage, so it resets per visit. */
        navCountKey: 'tavi_exit_nav_count',
        lastUrlKey: 'tavi_exit_last_url',
        navMinPages: 1,        // pages navigated before the trap arms
        tapGraceMs: 700,
        overlayGraceMs: 800,
        cartPath: '/cart',
        checkoutPath: '/checkout',
        excludePaths: ['/checkout', '/checkouts', '/orders', '/account', '/thank_you'],
        sessionKey: 'tavi_exit_intent_shown',     // sessionStorage — 1x per session
        capturedKey: 'tavi_exit_intent_captured',  // localStorage — never show again
        codeKey: 'tavi_exit_intent_code',      // localStorage — {code, expiresAt}
        // REPLACE: the localStorage key written by the SEPARATE Klaviyo new-customer
        // 20% off popup. Find it by submitting that popup in an incognito window and
        // reading DevTools > Application > Local Storage. Until replaced, this check
        // silently does nothing.
        klaviyoFormCapturedKey: 'SnRvGJ',
        saleActive: false,         // set true from Liquid to kill the popup sitewide
        isLoggedIn: false,         // set from Liquid: {% if customer %}
        currency: 'USD',
        moneyLocale: 'en-US',
        debug: false
    }, window.TAVI_EXIT_POPUP_CONFIG || {});
    if (CONFIG.debug && window.console) console.log('[toesox-] config', CONFIG);
    /* ── STATE ─────────────────────────────────────────────────────────────── */
    var root = null;   // the active popup root element for this viewport
    var cartData = null;
    var couponCode = null;
    var isOpen = false;
    var lastFocused = null;
    var keyListenerBound = false;

    /* ── iOS KEYBOARD FIX (mobile popup only) ─────────────────────────────────
       On iPhone, focusing the email field makes Safari push the page up, so the
       homepage showed below the popup. Three parts fix it:
         · the mobile popup is moved directly under <body>, so no theme parent
           (transform / overflow) can drag it along with the page
         · the page behind is frozen with position:fixed while the popup is open
         · the popup height follows window.visualViewport (the area above the
           keyboard) through the --tavi-vvh / --tavi-vv-top CSS variables */
    var vv = window.visualViewport;
    var pageLocked = false, savedScrollY = 0;

    function isMobileRoot() {
        return !!root && root.getAttribute('data-tavi-popup') === 'mobile';
    }

    function moveMobilePopupToBody(node) {
        if (node && node.getAttribute('data-tavi-popup') === 'mobile' && node.parentElement !== document.body) {
            document.body.appendChild(node);
        }
    }

    function syncViewport() {
        if (!pageLocked || !root || !vv) return;
        root.style.setProperty('--tavi-vvh', vv.height + 'px');
        root.style.setProperty('--tavi-vv-top', vv.offsetTop + 'px');
    }

    function lockPage() {
        document.body.style.overflow = 'hidden';
        if (!isMobileRoot() || pageLocked) return;
        pageLocked = true;
        savedScrollY = window.scrollY || window.pageYOffset || 0;
        document.documentElement.classList.add('tavi-popup-open');
        var b = document.body.style;
        b.position = 'fixed';
        b.top = -savedScrollY + 'px';
        b.left = '0';
        b.right = '0';
        b.width = '100%';
        syncViewport();
    }

    function unlockPage() {
        document.body.style.overflow = '';
        if (!pageLocked) return;
        pageLocked = false;
        document.documentElement.classList.remove('tavi-popup-open');
        var b = document.body.style;
        b.position = b.top = b.left = b.right = b.width = '';
        if (root) {
            root.style.removeProperty('--tavi-vvh');
            root.style.removeProperty('--tavi-vv-top');
        }
        window.scrollTo(0, savedScrollY);
    }

    if (vv) {
        vv.addEventListener('resize', syncViewport);
        vv.addEventListener('scroll', syncViewport);
    }

    function log() {
        if (CONFIG.debug && window.console) console.log.apply(console, ['[tavi-]'].concat([].slice.call(arguments)));
    }

    /* Drawer, is open? */
    var overlayClosedAt = 0;
    function overlayOpen() {
        try {
            if (document.querySelector(CONFIG.overlaySelectors)) return true;
        } catch (e) { /* ખોટો selector આખું popup ના તોડે */ }
        /* ઘણી themes scroll lock માટે body પર style મૂકે છે — એ પણ સંકેત છે.
           આપણું પોતાનું popup ખુલ્લું હોય ત્યારે આ ના ગણવું. */
        if (!isOpen && document.body.style.overflow === 'hidden') return true;
        return false;
    }

    /* ── DOM HELPERS ───────────────────────────────────────────────────────────
       Both markup variants (desktop + mobile) can be present in the DOM at once,
       so elements are addressed with data-el inside a scoped root — never with
       global IDs, which would collide between the two variants. */
    function el(name) { return root ? root.querySelector('[data-el="' + name + '"]') : null; }

    function escapeHTML(str) {
        return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    function money(cents) {
        try {
            return new Intl.NumberFormat(CONFIG.moneyLocale, {
                style: 'currency', currency: CONFIG.currency
            }).format(cents / 100);
        } catch (e) {
            return '$' + (cents / 100).toFixed(2);
        }
    }

    /* Storage can throw in Safari private mode — never let that break the page. */
    function store(type, action, key, value) {
        try {
            var s = type === 'session' ? window.sessionStorage : window.localStorage;
            if (action === 'get') return s.getItem(key);
            if (action === 'set') return s.setItem(key, value);
            if (action === 'del') return s.removeItem(key);
        } catch (e) { return null; }
    }

    /* ── ANALYTICS (brief §Reporting) ──────────────────────────────────────────
       Every event is pushed to dataLayer (GA4 via GTM) and dispatched as a DOM
       CustomEvent so any other tag manager / pixel can listen without editing
       this file. */
    function track(event, payload) {
        var data = Object.assign({ event: 'tavi_exit_popup_' + event }, payload || {});
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
        document.dispatchEvent(new CustomEvent('tavi:exit-popup:' + event, { detail: data }));
        log('event', data);
    }

    /* ── GATING (brief §"When the Popup Appears") ──────────────────────────────
       All conditions must pass. Returns a reason string when blocked, or null. */
    function blockedReason() {
        var path = window.location.pathname;

        // Never on checkout / order confirmation / account pages
        for (var i = 0; i < CONFIG.excludePaths.length; i++) {
          if (path.indexOf(CONFIG.excludePaths[i]) === 0) return 'excluded-page';
        }
        // Fully suppressed while a sitewide / promotional sale is running (manual toggle)
        if (CONFIG.saleActive) return 'sale-active';
        // First-time customers only — not logged in to an existing account
        if (CONFIG.isLoggedIn) return 'logged-in';
        // We already have their email from this popup — never show again (persists)
        if (store('local', 'get', CONFIG.capturedKey)) return 'already-captured';
        // They already redeemed the separate Klaviyo new-customer popup
        if (CONFIG.klaviyoFormCapturedKey && store('local', 'get', CONFIG.klaviyoFormCapturedKey)) {
          return 'klaviyo-popup-captured';
        }
        // Max once per session
        if (store('session', 'get', CONFIG.sessionKey)) return 'already-shown-session';
        return null;
    }

    /* ── CART ──────────────────────────────────────────────────────────────── */
    function fetchCart() {
        return fetch(shopRoot() + 'cart.js', { credentials: 'same-origin' })
            .then(function (r) { if (!r.ok) throw new Error('cart fetch failed'); return r.json(); });
    }

    function renderCart(cart) {
        var list = el('cart-items');
        var more = el('cart-more');
        if (!list) return;

        list.innerHTML = '';
        // Per-variant: desktop shows 2 products, mobile shows 1. Set with
        // data-max-items on the popup root; falls back to CONFIG.maxItemsShown.
        var maxItems = parseInt(root.getAttribute('data-max-items'), 10) || CONFIG.maxItemsShown;
        // var shown = cart.items.slice(0, maxItems);
            /* Shopify's /cart.js lists the most recently added item FIRST, so taking the
       first N showed the last N added. Reversing gives the order the customer
       actually built the cart in. slice() first so cart.items itself is untouched
       — the totals below still read the full, original array. */
    var shown = cart.items.slice().reverse().slice(0, maxItems);

        shown.forEach(function (item) {
            // Shopify image URLs support size params — request a small one, not the 2048px original
            var src = item.image ? item.image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_120x$1$2') : '';
            var div = document.createElement('div');
            div.className = 'cart-item';
            div.innerHTML =
                '<div class="cart-item-img">' +
                (src ? '<img src="' + escapeHTML(src) + '" alt="' + escapeHTML(item.title) + '" loading="lazy">' : '') +
                '</div>' +
                '<div class="cart-item-info">' +
                '<div class="cart-item-name">' + escapeHTML(item.product_title || item.title) +
                (item.quantity > 1 ? ' &times;' + item.quantity : '') + '</div>' +
                (item.variant_title && item.variant_title !== 'Default Title'
                    ? '<div class="cart-item-variant">' + escapeHTML(item.variant_title) + '</div>' : '') +
                '</div>';
            list.appendChild(div);
        });

        // "+N more items" — neither variant renders this any more, so the element
        // is absent and this block no-ops. It is kept so the line can be restored
        // by adding data-el="cart-more" back to the markup. Either way the totals
        // always reflect the FULL cart (brief §"What the Popup Shows").
        var hiddenCount = cart.items.reduce(function (n, i) { return n + (i.quantity || 1); }, 0)
            - shown.reduce(function (n, i) { return n + (i.quantity || 1); }, 0);
        if (more) {
            more.textContent = hiddenCount > 0 ? '+' + hiddenCount + ' more item' + (hiddenCount === 1 ? '' : 's') : '';
            more.style.display = hiddenCount > 0 ? '' : 'none';
        }

        // Pricing: always the whole cart. items_subtotal_price is the pre-cart-discount
        // subtotal and is the correct base for "what you'd save".
        var subtotal = (cart.items_subtotal_price != null) ? cart.items_subtotal_price : cart.total_price;
        var savings = Math.round(subtotal * CONFIG.discountPct);
        var newTotal = subtotal - savings;
        var count = cart.item_count != null
            ? cart.item_count
            : cart.items.reduce(function (n, i) { return n + (i.quantity || 1); }, 0);

        if (el('cart-count-label')) el('cart-count-label').textContent = 'Subtotal (' + count + ' item' + (count === 1 ? '' : 's') + ')';
        if (el('subtotal-val')) el('subtotal-val').textContent = money(subtotal);
        if (el('savings-val')) el('savings-val').textContent = '- ' + money(savings);
        if (el('total-val')) el('total-val').textContent = money(newTotal);
    }

    /* ── OPEN / CLOSE ──────────────────────────────────────────────────────── */
    function resolveRoot() {
        var wantDesktop = window.innerWidth >= CONFIG.desktopMinWidth;
        // Tablets get the DESKTOP popup. Route by viewport width, never by user
        // agent — iPadOS Safari no longer identifies as "iPad".
        var selector = wantDesktop ? '[data-tavi-popup="desktop"]' : '[data-tavi-popup="mobile"]';
        var node = document.querySelector(selector) || document.querySelector('[data-tavi-popup]');
        moveMobilePopupToBody(node); // iOS keyboard fix
        return node;
    }

    function open(opts) {
        if (isOpen) return Promise.resolve();

        // opts.force skips gating — used by QA / theme-editor preview only.
        console.log('blockedReason()',blockedReason())
        var reason = (opts && opts.force) ? null : blockedReason();
        if (reason) { log('blocked:', reason); return Promise.resolve(); }

        root = resolveRoot();
        if (!root) { log('no popup markup found'); return Promise.resolve(); }

        return fetchCart().then(function (cart) {
            // At least one item in the cart, or nothing happens — and crucially we do
            // NOT burn the once-per-session flag when the cart is empty, so the popup
            // is still available later in the same session once they add something.
            if (!cart || !cart.items || cart.items.length === 0) { log('empty cart'); return; }

            cartData = cart;
            if (cart.currency) CONFIG.currency = cart.currency;
            renderCart(cart);
            resetToStepOne();

            lastFocused = document.activeElement;
            root.hidden = false;
            // [hidden] is now a real display:none (see the snippet's CSS), so the
            // browser needs a frame with the element laid out before the opacity /
            // transform transition has anything to animate from. Two frames is the
            // reliable form of this — one is not, in Safari.
            requestAnimationFrame(function () {
                requestAnimationFrame(function () { if (isOpen && root) root.classList.add('active'); });
            });
            lockPage(); // was: document.body.style.overflow = 'hidden';
            isOpen = true;
            store('session', 'set', CONFIG.sessionKey, '1');

            bindDialogListeners();
            var input = el('email-input');
            if (input && window.innerWidth >= CONFIG.desktopMinWidth) input.focus();

            track('shown', {
                cart_value: (cart.items_subtotal_price || cart.total_price) / 100,
                cart_items: cart.item_count,
                variant: root.getAttribute('data-tavi-popup')
            });
        }).catch(function (e) { log('open failed', e); });
    }

    function close(reasonLabel) {
        if (!root || !isOpen) return;
        root.classList.remove('active');
        unlockPage(); // was: document.body.style.overflow = '';
        // Keep it out of the accessibility tree and out of the way of the other
        // variant while closed. The 350ms matches the CSS fade-out.
        setTimeout(function () { if (!isOpen && root) root.hidden = true; }, 350);
        isOpen = false;
        if (lastFocused && lastFocused.focus) lastFocused.focus();
        // Leaving for checkout is a conversion, not a dismissal — already tracked.
        if (reasonLabel !== 'checkout') track('dismissed', { reason: reasonLabel || 'close' });
    }

    function resetToStepOne() {
        var s1 = el('step-1'), s2 = el('step-2'), btn = el('redeem-btn'), input = el('email-input'), err = el('error-msg');
        if (s1) s1.style.display = '';
        if (s2) { s2.classList.remove('active'); s2.style.display = ''; }
        if (btn) { btn.disabled = false; btn.classList.remove('loading'); }
        if (input) { input.value = ''; input.classList.remove('error'); }
        if (err) err.classList.remove('visible');
    }

    /* ── SUBMIT (brief §"How It Works" — Step 1) ───────────────────────────── */
    function handleSubmit(e) {
        if (e) e.preventDefault();

        var input = el('email-input'), err = el('error-msg'), btn = el('redeem-btn');
        var email = (input.value || '').trim();

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            input.classList.add('error');
            err.textContent = 'Please enter a valid email address.';
            err.classList.add('visible');
            input.focus();
            return;
        }
        input.classList.remove('error');
        err.classList.remove('visible');
        input.blur(); // dismiss the mobile keyboard before the step change

        btn.disabled = true;
        btn.classList.add('loading');

        // ── Server creates the unique, single-use, time-limited code. It also
        //    subscribes the email to the Klaviyo list. Never create codes in the
        //    browser — that requires Admin API credentials.
        //
        //    The endpoint is a plain public URL on another origin, so:
        //      · no `credentials` — cookies are not sent cross-origin anyway, and
        //        'include' would demand a stricter CORS contract we don't need
        //      · X-TAVI-Key identifies the storefront to the backend
        //    Both headers are on the server's allowedHeaders list; adding any
        //    other header here will fail the CORS preflight.
        var reqHeaders = { 'Content-Type': 'application/json' };
        if (CONFIG.publicKey) reqHeaders['X-TAVI-Key'] = CONFIG.publicKey;
        // TEST ONLY — ngrok serves an HTML interstitial to browser user-agents
        // without this, which makes r.json() throw. Auto-removes itself once the
        // endpoint is no longer an ngrok URL.
        if (/ngrok/.test(CONFIG.endpoint)) reqHeaders['ngrok-skip-browser-warning'] = 'true';

        /* Without a timeout a hung request leaves the button spinning forever.
           20s is longer than the server's own worst case, so a slow-but-working
           request is never cut off. */
        var controller = window.AbortController ? new AbortController() : null;
        var abortTimer = controller ? setTimeout(function () { controller.abort(); }, CONFIG.submitTimeoutMs || 20000) : null;

        fetch(CONFIG.endpoint, {
            method: 'POST',
            headers: reqHeaders,
            signal: controller ? controller.signal : undefined,
            body: JSON.stringify({
                website: (el('hp') ? el('hp').value : ''),
                email: email,
                cart_token: cartData && cartData.token,
                cart_total: cartData && (cartData.items_subtotal_price || cartData.total_price),
                currency: CONFIG.currency,
                source: 'exit_intent_popup'
            })
        })
            .then(function (r) {
                // A non-JSON body means something intercepted the request — almost always
                // the ngrok interstitial page, or an nginx/Cloudflare error page. Say so
                // in the console instead of throwing an opaque SyntaxError.
                return r.text().then(function (text) {
                    var data;
                    try { data = JSON.parse(text); }
                    catch (e) {
                        log('non-JSON response, status', r.status, text.slice(0, 300));
                        var bad = new Error('bad_response_' + r.status);
                        bad.status = r.status;
                        bad.requestId = r.headers.get('X-Request-Id');
                        throw bad;
                    }
                    data.__status = r.status;
                    return data;
                });
            })
            .then(function (data) {
                if (!data || !data.success || !data.code) {
                    /* Carry the server's own message and request_id through to the
                       catch below — the message is what the customer should read,
                       the request_id is what finds this attempt in CloudWatch. */
                    var fail = new Error((data && data.error) || 'code generation failed');
                    fail.status = data && data.__status;
                    fail.requestId = data && data.request_id;
                    fail.serverMessage = data && data.message;
                    throw fail;
                }

                /* From here on the code EXISTS. Nothing below may reach the catch —
                   before, a failure in the cart calls or analytics showed "Something
                   went wrong" to a customer whose code had already been created. */
                clearTimeout(abortTimer);
                onCodeIssued(data);
            })
            .catch(function (e2) {
                clearTimeout(abortTimer);

                var reason = (e2 && e2.message) || 'unknown';
                /* fetch() rejects with a TypeError for DNS/offline/CORS/ad-blocker
                   failures and an AbortError for our timeout. Neither ever reached the
                   server's handler, so neither has a request_id. */
                if (e2 && e2.name === 'AbortError') reason = 'client_timeout';
                else if (e2 && e2.name === 'TypeError') reason = 'network_error';

                btn.disabled = false;
                btn.classList.remove('loading');

                /* Always on, not behind CONFIG.debug: one line in the console is the only
                   way to tell a customer's failure apart after the fact. Paste the
                   request_id into CloudWatch to get the server's side of the story. */
                if (window.console) {
                    console.warn('TS-exit] submit failed', {
                        reason: reason,
                        status: (e2 && e2.status) || null,
                        request_id: (e2 && e2.requestId) || null,
                        detail: e2 && e2.message
                    });
                }

                // The customer only ever sees a friendly line. The server's `message`
                // wins when present; the mapping below covers an older server and the
                // failures that never got a response at all.
                var message = 'Something went wrong. Please try again.';
                if (e2 && e2.serverMessage) {
                    message = e2.serverMessage;
                } else if (reason === 'network_error') {
                    message = "We couldn't connect. Please check your connection and try again.";
                } else if (reason === 'client_timeout') {
                    message = 'This is taking longer than expected. Please try again.';
                } else if (reason === 'already_issued') {
                    message = 'A code has already been sent for this email address.';
                } else if (reason === 'already_subscribed') {
                    // Server found this email on the welcome-popup Klaviyo list — they are
                    // already holding an offer, so a second one would stack two discounts
                    // on one customer. Not an error on their part; say so kindly.
                    message = 'Looks like you are already subscribed. Welcome back!';
                } else if (reason === 'rate_limited' || reason === 'daily_cap_reached') {
                    message = 'Too many requests right now. Please try again shortly.';
                } else if (reason === 'Invalid email address') {
                    message = 'Please enter a valid email address.';
                }

                // These three are never the customer's fault — they mean the popup is
                // misconfigured and NOBODY can redeem. They must be loud in the console.
                if (reason === 'origin_not_allowed') {
                    log('CONFIG ERROR: this storefront origin is missing from ALLOWED_ORIGINS on the server.');
                } else if (reason === 'bad_key') {
                    log('CONFIG ERROR: CONFIG.publicKey does not match TAVI_PUBLIC_KEY on the server.');
                } else if (reason.indexOf('bad_response_') === 0) {
                    log('CONFIG ERROR: endpoint did not return JSON. Check the endpoint URL and, on ngrok, the skip-browser-warning header.');
                }

                err.textContent = message;
                err.classList.add('visible');
                track('error', {
                    stage: 'submit',
                    reason: reason,
                    http_status: (e2 && e2.status) || null,
                    request_id: (e2 && e2.requestId) || null
                });
            });
    }

    /* Success path, split out so it can never fall into the submit error UI. The
       code is shown FIRST — it is already in hand — and every step after it is
       isolated: a storage, analytics or cart failure is logged and ignored, since
       goToCart() applies the code again on the way out anyway. */
    function onCodeIssued(data) {
        couponCode = data.code;
        var expiresAt = data.expires_at || (Date.now() + CONFIG.expiryMinutes * 60000);

        showStepTwo(couponCode);

        try {
            // Persist: never show this popup again for this browser (brief: "we do not
            // already have their email"), and remember the code + its expiry.
            store('local', 'set', CONFIG.capturedKey, '1');
            store('local', 'set', CONFIG.codeKey, JSON.stringify({ code: couponCode, expiresAt: expiresAt }));
            scheduleExpiry(expiresAt);
            track('email_submitted', {
                code: couponCode,
                reissued: Boolean(data.reissued),
                request_id: data.request_id || null,
                cart_value: cartData ? (cartData.items_subtotal_price || cartData.total_price) / 100 : null
            });
        } catch (e) {
            if (window.console) console.warn('[ts-exit] post-issue bookkeeping failed (code still shown)', e);
        }

        /* Sequential, not parallel: two /cart/update.js calls in flight at once can
           race, and the later one may land on a cart state that lacks the other's
           change. Tag for reporting first, then apply the code (brief §Integrations). */
        tagCart(couponCode).then(function () { return applyCodeToCart(couponCode); });
    }

    function showStepTwo(code) {
        var s1 = el('step-1'), s2 = el('step-2'), btn = el('redeem-btn');
        if (el('code-text')) el('code-text').textContent = code;
        if (s1) s1.style.display = 'none';
        if (s2) { s2.classList.add('active'); s2.style.display = 'flex'; }
        if (btn) { btn.disabled = false; btn.classList.remove('loading'); }
        var cta = el('checkout-btn');
        if (cta) cta.focus();
    }

    /* ── APPLYING THE CODE TO THE CART ─────────────────────────────────────────
       Shopify's Ajax Cart API has no "add discount code" method. The supported
       way on the Online Store is to hit /discount/{code}, which writes the
       discount onto the current cart session; fetching it in the background does
       this without navigating the customer away. Verify on staging that
       /cart.js afterwards reports the discount in cart_level_discount_applications
       — some checkout extensibility setups only surface it at checkout.
       goToCart() below repeats the same call as a redirect, so even if the
       background call is blocked the customer still lands with the code applied. */
    /* Locale-aware cart root. On a multi-currency/multi-locale store this is
       '/en-gb/' etc, and hard-coding '/cart/update.js' silently 404s. */
    function shopRoot() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function applyCodeToCart(code) {
        return fetch(shopRoot() + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: code })
        })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                log('code applied to cart', code, cart && cart.cart_level_discount_applications);
            })
            .catch(function (e) {
                log('background apply failed — the goToCart() redirect fallback will cover it', e);
            });
    }

    /* ── REMOVING OUR DISCOUNT ────────────────────────────────────────────────
       { discount: '' } clears whatever discount code sits on the cart — Shopify
       gives no way to remove one code by name. So never call it blind: read the
       cart first and bail out if anything other than a TAVI code is applied,
       otherwise expiry would silently wipe a code the customer entered
       themselves or one a support agent gave them. */
    function removeTaviCartDiscount() {
        return fetch(shopRoot() + 'cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                var apps = (cart && cart.cart_level_discount_applications) || [];
                if (!apps.length) { log('no cart discount to remove'); return; }

                var ours = apps.filter(function (a) {
                    var t = String((a && a.title) || '').toUpperCase();
                    return t.indexOf('TS-') === 0;
                });

                if (ours.length !== apps.length) {
                    log('skipping removal — a non-TAVI discount is on the cart', apps);
                    return;
                }

                return fetch(shopRoot() + 'cart/update.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ discount: '' })
                }).then(function () { log('expired TAVI discount removed from cart'); });
            })
            .catch(function (e) { log('discount removal failed', e); });
    }

    /* Cart attribute makes the order filterable/exportable in Shopify Admin. */
    function tagCart(code) {
        return fetch(shopRoot() + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'Exit Intent Popup': 'true', 'Exit Intent Code': code } })
        }).catch(function () { /* non-critical */ });
    }

    /* ── STEP 2 CTA ────────────────────────────────────────────────────────── */
    function goToCart() {
        track('checkout_click', { code: couponCode });
        close('checkout');
        // /discount/{code}?redirect=... is the universal Shopify method and stacks
        // correctly with free shipping when combinesWith.shippingDiscounts is set
        // on the price rule (see the server endpoint file).
        var url = couponCode
            ? shopRoot() + 'discount/' + encodeURIComponent(couponCode) + '?redirect=' + CONFIG.checkoutPath
            : CONFIG.checkoutPath;
        if (CONFIG.demo) { log('demo mode — would navigate to', url); return; }
        window.location.href = url;
    }

    function copyCode() {
        var code = el('code-text') ? el('code-text').textContent : '';
        var btn = el('copy-btn');
        var done = function () {
            if (!btn) return;
            btn.classList.add('copied');
            btn.setAttribute('aria-label', 'Copied');
            clearTimeout(copyCode._t);
            copyCode._t = setTimeout(function () {
                btn.classList.remove('copied');
                btn.setAttribute('aria-label', 'Copy discount code');
            }, 1600);
            track('code_copied', { code: code });
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done).catch(fallbackCopy);
        } else { fallbackCopy(); }

        function fallbackCopy() {
            var ta = document.createElement('textarea');
            ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0';
            document.body.appendChild(ta); ta.select();
            try { document.execCommand('copy'); } catch (e) { }
            document.body.removeChild(ta);
            done();
        }
    }

    /* ── EXPIRY (brief §"How It Works" — Expiry) ───────────────────────────────
       Enforcement is server-side: the price rule carries endsAt, so Shopify itself
       rejects the code at checkout once the window closes — that is the guarantee.
       Client-side we clear our stored state so an expired code is never re-applied,
       and clear the cart attribute. There is no Online Store API to force-remove a
       discount from a cart session, so do not expect the cart page to visually drop
       it before checkout; Shopify drops it at checkout. */
    function scheduleExpiry(expiresAt) {
        var ms = expiresAt - Date.now();
        if (ms <= 0) { clearExpiredCode(); return; }
        setTimeout(clearExpiredCode, Math.min(ms, 2147483647));
    }

    function clearExpiredCode() {
        var raw = store('local', 'get', CONFIG.codeKey);
        if (!raw) return;
        try {
            var saved = JSON.parse(raw);
            if (saved.expiresAt && Date.now() < saved.expiresAt) { scheduleExpiry(saved.expiresAt); return; }
        } catch (e) { }
        store('local', 'del', CONFIG.codeKey);
        couponCode = null;

        // Clear the reporting attribute...
        fetch(shopRoot() + 'cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'Exit Intent Code': '' } })
        }).catch(function () { });

        // ...and actually take the dead code off the cart. Shopify rejects it at
        // checkout regardless, but leaving it visible on the cart page shows the
        // customer a discounted total they can no longer have.
        removeTaviCartDiscount();

        track('code_expired', {});
    }

    /* ── DIALOG LISTENERS (bound once, on first open) ──────────────────────── */
    function bindDialogListeners() {
        if (!root) return;

        // Bound per root, because the active root changes if the viewport crosses
        // the desktop/mobile breakpoint between opens.
        if (root.getAttribute('data-tavi-bound') === 'true') return;
        root.setAttribute('data-tavi-bound', 'true');

        root.addEventListener('click', function (e) {
            var action = e.target.closest && e.target.closest('[data-action]');
            if (action) {
                e.preventDefault();
                var name = action.getAttribute('data-action');
                if (name === 'close') close('x');
                if (name === 'copy') copyCode();
                if (name === 'checkout') goToCart();
                return;
            }
            // Backdrop click (desktop only — the mobile variant is full screen, so
            // e.target === root never fires there)
            // if (e.target === root) close('backdrop');
        });

        var form = el('email-form');
        if (form) form.addEventListener('submit', handleSubmit);

        // iOS keyboard fix: once the keyboard is up, bring the email field
        // (and the Redeem button under it) into the middle of the popup.
        root.addEventListener('focusin', function (e) {
            if (!isMobileRoot() || !e.target || e.target.tagName !== 'INPUT') return;
            var input = e.target;
            setTimeout(function () {
                if (input.scrollIntoView) input.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }, 300);
        });

        if (!keyListenerBound) {
            keyListenerBound = true;
            document.addEventListener('keydown', function (e) {
                if (!isOpen) return;
                // if (e.key === 'Escape') { close('escape'); return; }
                if (e.key === 'Tab') trapFocus(e);
            });
        }
    }

    /* Keep keyboard focus inside the modal while it is open (WCAG 2.4.3 / 2.1.2). */
    function trapFocus(e) {
        var focusables = root.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        var visible = Array.prototype.filter.call(focusables, function (n) { return n.offsetParent !== null; });
        if (!visible.length) return;
        var first = visible[0], last = visible[visible.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* ── EXIT INTENT TRIGGERS ──────────────────────────────────────────────── */

    /* Nothing is allowed to fire in the first few seconds. A visitor who just
       landed has not decided to leave — they are still finding their bearings,
       and the mouse crossing the top edge during that is almost always them
       reaching for a tab or the address bar out of habit. */
    var armedAt = Date.now();
    function armed() {
        if (Date.now() - armedAt < CONFIG.armDelayMs) { log('trigger ignored — page too fresh'); return false; }
        return true;
    }

    /* ── OVERLAY AWARENESS ────────────────────────────────────────────────────
       The reported false positive: cart drawer open, customer moves to its
       close button at the top right, mouse crosses the top edge, popup fires.
       They were closing a drawer, not leaving the site. Two guards — the drawer
       being open, and a grace period after it closes, because the pointer is
       still up in that corner for a moment afterwards. */
    var overlayClosedAt = 0, wasOverlayOpen = false;

    function overlayOpen() {
        try {
            if (CONFIG.overlaySelectors && document.querySelector(CONFIG.overlaySelectors)) return true;
        } catch (e) {
            /* A malformed selector must never take the whole popup down with it. */
            log('bad overlaySelectors — ignoring', e);
        }
        /* Most themes lock body scroll while a drawer is open. Our own popup does
           the same, so exclude that case or we would block ourselves. */
        if (!isOpen && document.body.style.overflow === 'hidden') return true;
        return false;
    }

    /* Polling rather than MutationObserver: themes open drawers by class, by
       attribute, by custom element and by inline style, and a 200ms poll catches
       all of them for a fraction of the complexity. */
    function watchOverlays() {
        setInterval(function () {
            var now = overlayOpen();
            if (wasOverlayOpen && !now) overlayClosedAt = Date.now();
            wasOverlayOpen = now;
        }, 200);
    }

    function overlayClear() {
        if (overlayOpen()) { log('trigger ignored — overlay open'); return false; }
        if (Date.now() - overlayClosedAt < CONFIG.overlayGraceMs) {
            log('trigger ignored — overlay just closed');
            return false;
        }
        return true;
    }

    function setupDesktopExitIntent() {
        /* Pointer speed, smoothed. One jittery sample should not decide this, so
           each reading is averaged with the last. Negative = travelling upward. */
        var lastY = null, lastT = 0, velocity = 0;

        document.addEventListener('mousemove', function (e) {
            var now = Date.now();
            if (lastY !== null && now > lastT) {
                var v = (e.clientY - lastY) / (now - lastT);
                velocity = velocity * 0.5 + v * 0.5;
            }
            lastY = e.clientY;
            lastT = now;
        }, { passive: true });

        // documentElement, not document — mouseleave on the document object does
        // not fire reliably across browsers.
        document.documentElement.addEventListener('mouseleave', function (e) {
            if (e.clientY > 0) return;                                   // top edge only
            if (window.matchMedia && !window.matchMedia('(pointer: fine)').matches) return;

            if (!armed()) return;
            if (!overlayClear()) return;

            if (e.clientX > window.innerWidth * CONFIG.exitZoneRatio) {
                log('exit ignored — right zone', e.clientX);
                return;
            }
            if (velocity > -CONFIG.exitMinVelocity) {
                log('exit ignored — too slow', velocity.toFixed(2));
                return;
            }

            open();
        });
    }

    function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { } }

    /* Counts real navigations this session and returns the running total.
       Compares against the last URL rather than just incrementing, so a reload
       or a hash change does not count as having gone anywhere.
       MUST run on every page load, including the entry page — otherwise the
       counter never advances and the trap never arms. */
    function recordPageView() {
        var here = location.href.split('#')[0];
        var last = ssGet(CONFIG.lastUrlKey);
        var count = Number(ssGet(CONFIG.navCountKey)) || 0;

        if (last && last !== here) {
            count += 1;
            ssSet(CONFIG.navCountKey, String(count));
        }
        ssSet(CONFIG.lastUrlKey, here);
        return count;
    }

    function setupMobileExitIntent() {
        /* ── BACK BUTTON ──────────────────────────────────────────────────────
           First press is ours, second belongs to the customer. A guard entry is
           pushed so the first back press lands here instead of leaving the page.
    
           backGuardUsed is what makes the second press work. Without it, a
           customer who dismissed the popup and pressed back again would have that
           press silently swallowed — the guard entry is still on the stack, we
           decline to open (session flag set), and nothing happens. Pressing back
           and going nowhere is a worse experience than the popup itself. */
        var backGuardUsed = false;
        var navCount = recordPageView();

        if (navCount >= CONFIG.navMinPages) {

            try { history.pushState({ taviPopupGuard: true }, ''); } catch (e) { }

            window.addEventListener('popstate', function () {
                if (isOpen) return;                 // popup already up: let the press through

                if (backGuardUsed) {
                    log('back press passed through — guard already used');
                    return;
                }

                /* Not eligible (too fresh, drawer open, already captured)? Burn the
                  guard anyway. Otherwise every subsequent back press keeps getting
                  consumed by a popup that is never going to appear. */
                if (!armed() || !overlayClear() || blockedReason()) {
                    backGuardUsed = true;
                    log('back press passed through — not eligible');
                    return;
                }

                backGuardUsed = true;
                open().then(function () {
                    if (isOpen) { try { history.pushState({ taviPopupGuard: true }, ''); } catch (e) { } }
                });
            });
        } else {
            /* Entry page: no guard pushed, so back behaves exactly as the browser
              intends and takes them back to Google or wherever they came from. */
            log('back trap NOT armed — still on the entry page');
        }

        /* ── FAST UPWARD FLICK ────────────────────────────────────────────────
           The old rule fired on any upward scroll that ended near the top, which
           caught people scrolling back up to re-read something. Four conditions
           now, and all must hold:
             · they went well down the page at some point   (real reading)
             · the upward burst covered real distance       (a flick, not a nudge)
             · it happened fast                             (committed, not browsing)
             · no tap just before it                        (accordions, anchors,
                                                             swatches all scroll) */
        var lastTouchAt = 0;
        ['touchstart', 'touchend'].forEach(function (evt) {
            window.addEventListener(evt, function () { lastTouchAt = Date.now(); }, { passive: true });
        });

        var lastY = window.scrollY;
        var maxDepth = window.scrollY;
        var burstStartY = null, burstStartT = 0;

        window.addEventListener('scroll', function () {
            var y = window.scrollY, now = Date.now();

            if (y > maxDepth) maxDepth = y;

            var movedUp = lastY - y;
            lastY = y;

            if (movedUp <= 0) { burstStartY = null; return; }   // downward: reset

            /* Start a new burst, or continue the current one if it is still young. */
            if (burstStartY === null || now - burstStartT > CONFIG.scrollUpMaxDurationMs) {
                burstStartY = y + movedUp;
                burstStartT = now;
            }

            if (y > CONFIG.scrollUpTopPx) return;               // not at the top yet

            if (maxDepth < CONFIG.scrollMinDepthPx) {
                log('scroll ignored — never went deep', maxDepth);
                return;
            }

            var distance = burstStartY - y;
            if (distance < CONFIG.scrollUpMinDistancePx) {
                log('scroll ignored — short burst', distance);
                return;
            }
            if (now - burstStartT > CONFIG.scrollUpMaxDurationMs) {
                log('scroll ignored — too slow', now - burstStartT);
                return;
            }
            if (now - lastTouchAt < CONFIG.tapGraceMs) {
                log('scroll ignored — just tapped');
                return;
            }
            if (!armed()) return;
            if (!overlayClear()) return;

            burstStartY = null;
            open();
        }, { passive: true });
    }

    /* ── INIT ──────────────────────────────────────────────────────────────── */
    function init() {
        if (blockedReason()) { log('init blocked:', blockedReason()); return; }

        // Re-check any code stored from an earlier pageview so expiry survives
        // navigation and reloads.
        var saved = store('local', 'get', CONFIG.codeKey);
        if (saved) {
            try {
                var parsed = JSON.parse(saved);
                couponCode = parsed.code;
                scheduleExpiry(parsed.expiresAt);
            } catch (e) { store('local', 'del', CONFIG.codeKey); }
        }

        watchOverlays();
        if (window.innerWidth >= CONFIG.desktopMinWidth) setupDesktopExitIntent();
        else setupMobileExitIntent();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    // Exposed for QA / theme editor preview only.
    window.TaviExitPopup = { open: open, close: close, config: CONFIG };
})();
